import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@/components/foundation/Spinner';
import { isAdminAuthenticated } from '@/lib/auth/admin-auth';
import { bootstrapTenantSessionFromUrl } from '@/lib/auth/bootstrap-url-session';
import { isTenantAuthenticated } from '@/lib/auth/tenant-auth';
import type { Portal } from '@/types/api';

interface AuthGuardProps {
  portal: Portal;
  children: ReactNode;
  fallback?: ReactNode;
}

export function AuthGuard({ portal, children, fallback }: AuthGuardProps) {
  const location = useLocation();

  if (portal === 'tenant') {
    bootstrapTenantSessionFromUrl();
  }

  const authenticated = portal === 'admin' ? isAdminAuthenticated() : isTenantAuthenticated();

  if (!authenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return (
      <Navigate
        to={`/public/login?portal=${portal}&redirect=${redirect}`}
        replace
      />
    );
  }

  return <>{fallback ?? children}</>;
}

export function AuthGateSpinner() {
  return <Spinner label="Checking session" />;
}
